import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '漫画画廊', href: '#media' },
  { label: '关于虫虫', href: '#about' },
  { label: '平台特色', href: '#features' },
  { label: '热门推荐', href: '#cards' },
  { label: 'APP下载', href: '#app' },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-read-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-bold text-foreground-900 font-heading whitespace-nowrap">
              虫虫漫画网
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-md hover:bg-primary-50/60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-foreground-600 text-sm"></i>
            </button>
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg border border-background-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-foreground-700`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden fixed inset-0 top-[72px] bg-background-50 z-40 overflow-y-auto">
            <div className="flex flex-col p-4 gap-1">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="px-4 py-3 text-base font-medium text-foreground-800 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
              <div className="mt-4 pt-4 border-t border-background-200">
                <a
                  href="#app"
                  onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
                  className="block w-full text-center px-4 py-3 text-base font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors cursor-pointer"
                >
                  开始阅读
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}